"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNavSelectedListItemProvider = GlobalNavSelectedListItemProvider;
exports.useGlobalNavV2 = useGlobalNavV2;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var GlobalNavSelectedListItem = (0, react_1.createContext)(null);
var GlobalNavSelectListItem = (0, react_1.createContext)(function () { return null; });
function GlobalNavSelectedListItemProvider(props) {
    var _a = (0, react_1.useState)(null), app = _a[0], setGlobalNavListItem = _a[1];
    return ((0, jsx_runtime_1.jsx)(GlobalNavSelectedListItem.Provider, { value: app, children: (0, jsx_runtime_1.jsx)(GlobalNavSelectListItem.Provider, { value: setGlobalNavListItem, children: props.children }) }));
}
function useGlobalNavV2() {
    var selected = (0, react_1.useContext)(GlobalNavSelectedListItem);
    var select = (0, react_1.useContext)(GlobalNavSelectListItem);
    return { selected: selected, select: select };
}
